// Components, Layouts, Pages
import {
  CrmCommonPage,
  JobsCommonPage,
  LeadCommonPage,
  TaskCommonPage,
  UserCommonPage,
  VenueCommonPage,
  OrderCommonPage,
  QuotesCommonPage,
  TrucksCommonPage,
  ClientCommonPage,
  GlobalCommonPage,
  ReportsCommonPage,
  TrailerCommonPage,
  PackageCommonPage,
  InvoiceCommonPage,
  VendorsCommonPage,
  CouponsCommonPage,
  ScheduleCommonPage,
  SettingsCommonPage,
  CategoryCommonPage,
  UserFormCommonPage,
  VehiclesCommonPage,
  DashboardCommonPage,
  EquipmentCommonPage,
  InventoryCommonPage,
  EventTypeCommonPage,
  RoleFormCommonPage,
  VenueFormCommonPage,
  OrderFormCommonPage,
  ChecklistCommonPage,
  JobDetailCommonPage,
  QuarantineCommonPage,
  QuotesFormCommonPage,
  UserDetailCommonPage,
  ClientFormCommonPage,
  InventoriesCommonPage,
  PackageFormCommonPage,
  VenueDetailCommonPage,
  InvoiceFormCommonPage,
  ClientDetailCommonPage,
  QuotesDetailCommonPage,
  OrderDetailsCommonPage,
  PurchaseOrderCommonPage,
  InventoryFormCommonPage,
  RevenueReportCommonPage,
  DeliveryReportCommonPage,
  TaskCompletionCommonPage,
  VendorsDetailsCommonPage,
  RoleManagementCommonPage,
  InventoryDetailCommonPage,
  JobCostingReportCommonPage,
  QuarantineReportCommonPage,
  QuoteRevenueReportCommonPage,
  OrderRevenueReportCommonPage,
  CancellationReportCommonPage,
  ClientIncomeReportCommonPage,
  FeatureUtilizationCommonPage,
  ReportsForemanTaskCommonPage,
  DiscountUsageReportCommonPage,
  PurchaseOrderDetailsCommonPage,
  ReportsFinancialOrderCommonPage,
  ReportsInventoryUsageCommonPage,
  ReportsOverbookingItemCommonPage,
  ReportsMarketingRevenueCommonPage,
  GeographicRevenueReportCommonPage,
  ReportsSubrentalsReportCommonPage,
  ReportsTransactionSummaryCommonPage,
} from '~/pages/common';
// Others
import { MenuNameEnum } from '~/utils/enum/common';
import { IRouteModel } from '~/utils/interface/base';
import { adminRoute, adminRouteAbsolute } from '../roleRoutes/admin';
// Styles, images, icons
import { icons } from '~/assets';

export const privateAdminRoutes: IRouteModel[] = [
  // Dashboard
  {
    index: true,
    path: adminRoute.base,
    component: DashboardCommonPage,
    name: MenuNameEnum.DASHBOARD,
    icon: icons.menuIconDashboardUnactive,
    activeIcon: icons.menuIconDashboardActive,
  },

  // Global
  {
    path: adminRouteAbsolute.global,
    component: GlobalCommonPage,
  },

  // CRM
  {
    path: adminRouteAbsolute.crm,
    component: CrmCommonPage,
    name: MenuNameEnum.CRM,
    icon: icons.menuIconCrmUnactive,
    activeIcon: icons.menuIconCrmActive,
    children: [
      {
        path: adminRouteAbsolute.leads,
        component: LeadCommonPage,
        name: MenuNameEnum.LEADS,
      },
      {
        path: adminRouteAbsolute.clients,
        component: ClientCommonPage,
        name: MenuNameEnum.CLIENT,
      },
    ],
  },
  {
    path: adminRouteAbsolute.createLead,
    component: ClientFormCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.crm}${adminRoute.leads}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: ClientFormCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.crm}${adminRoute.leads}${adminRoute.commonDetail}`,
    component: ClientDetailCommonPage,
  },
  {
    path: adminRouteAbsolute.createClient,
    component: ClientFormCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.crm}${adminRoute.clients}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: ClientFormCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.crm}${adminRoute.clients}${adminRoute.commonDetail}`,
    component: ClientDetailCommonPage,
  },

  // Schedule
  {
    path: adminRouteAbsolute.schedule,
    component: ScheduleCommonPage,
    name: MenuNameEnum.SCHEDULE,
    icon: icons.menuIconScheduleUnactive,
    activeIcon: icons.menuIconScheduleActive,
  },

  // Jobs
  {
    path: adminRouteAbsolute.jobs,
    component: JobsCommonPage,
    name: MenuNameEnum.JOBS,
    icon: icons.menuIconJobsUnactive,
    activeIcon: icons.menuIconJobsActive,
  },
  {
    path: `${adminRoute.base}${adminRoute.jobs}${adminRoute.commonDetail}`,
    component: JobDetailCommonPage,
  },

  // Task
  {
    path: adminRouteAbsolute.task,
    name: MenuNameEnum.TASKS,
    icon: icons.menuIconTaskInActive,
    activeIcon: icons.menuIconTaskActive,
    component: TaskCommonPage,
  },

  // Communication
  // {
  //   path: adminRouteAbsolute.communication,
  //   component: CommunicationCommonPage,
  //   name: MenuNameEnum.COMMUNICATION,
  //   icon: icons.menuIconCommunicationUnactive,
  //   activeIcon: icons.menuIconCommunicationActive,
  // },

  // Quotes
  {
    path: adminRouteAbsolute.quotes,
    component: QuotesCommonPage,
    name: MenuNameEnum.QUOTES,
    icon: icons.menuIconQuotesUnactive,
    activeIcon: icons.menuIconQuotesActive,
  },
  {
    path: adminRouteAbsolute.createQuotes,
    component: QuotesFormCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.quotes}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: QuotesFormCommonPage,
  },

  //  Order
  {
    path: adminRouteAbsolute.order,
    component: OrderCommonPage,
    name: MenuNameEnum.ORDER,
    icon: icons.menuIconOrderInactive,
    activeIcon: icons.menuIconOrderActive,
  },
  {
    path: `${adminRoute.base}${adminRoute.order}${adminRoute.commonDetail}`,
    component: OrderDetailsCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.order}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: OrderFormCommonPage,
  },

  // Invoice
  {
    path: adminRouteAbsolute.invoices,
    component: InvoiceCommonPage,
    name: MenuNameEnum.INVOICE,
    icon: icons.menuIconInvoiceInactive,
    activeIcon: icons.menuIconInvoiceActive,
  },
  {
    path: adminRouteAbsolute.createInvoice,
    component: InvoiceFormCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.invoice}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: InvoiceFormCommonPage,
  },

  // Inventories
  {
    path: `${adminRoute.base}${adminRoute.quotes}${adminRoute.commonDetail}`,
    component: QuotesDetailCommonPage,
  },
  {
    path: adminRouteAbsolute.inventories,
    component: InventoriesCommonPage,
    name: MenuNameEnum.INVENTORY,
    icon: icons.menuIconInventoryInactive,
    activeIcon: icons.menuIconInventoryActive,
    children: [
      {
        path: adminRouteAbsolute.inventory,
        component: InventoryCommonPage,
        name: MenuNameEnum.PRODUCT,
      },
      {
        path: adminRouteAbsolute.package,
        component: PackageCommonPage,
        name: MenuNameEnum.PACKAGE,
      },
      {
        path: adminRouteAbsolute.quarantine,
        component: QuarantineCommonPage,
        name: MenuNameEnum.QUARANTINE,
      },
    ],
  },
  {
    path: adminRouteAbsolute.createInventory,
    component: InventoryFormCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.inventory}${adminRoute.product}${adminRoute.commonDetail}`,
    component: InventoryDetailCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.inventory}${adminRoute.product}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: InventoryFormCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.inventory}${adminRoute.package}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: PackageFormCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.inventory}${adminRoute.package}${adminRoute.commonDetail}${adminRoute.commonClone}`,
    component: PackageFormCommonPage,
  },

  // Report
  {
    path: `${adminRoute.base}${adminRoute.reports}`,
    component: ReportsCommonPage,
    name: MenuNameEnum.REPORTS,
    icon: icons.menuIconReportUnactive,
    activeIcon: icons.menuIconReportActive,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.overbookingItem}`,
    component: ReportsOverbookingItemCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.subrentalsReport}`,
    component: ReportsSubrentalsReportCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.clientIncomeReport}`,
    component: ClientIncomeReportCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.revenueReport}`,
    component: RevenueReportCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.geographicRevenueReport}`,
    component: GeographicRevenueReportCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.quoteRevenueReport}`,
    component: QuoteRevenueReportCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.orderRevenueReport}`,
    component: OrderRevenueReportCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.cancellationReport}`,
    component: CancellationReportCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.deliveryReport}`,
    component: DeliveryReportCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.taskCompletionReport}`,
    component: TaskCompletionCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.discountUsageReport}`,
    component: DiscountUsageReportCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.featureUtilizationReport}`,
    component: FeatureUtilizationCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.jobCostingReport}`,
    component: JobCostingReportCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.inventoryUsageReport}`,
    component: ReportsInventoryUsageCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.quarantineReport}`,
    component: QuarantineReportCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.foremanTaskReport}`,
    component: ReportsForemanTaskCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.marketingRevenueReport}`,
    component: ReportsMarketingRevenueCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.financialOrderReport}`,
    component: ReportsFinancialOrderCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.reports}${adminRoute.transactionSummaryReport}`,
    component: ReportsTransactionSummaryCommonPage,
  },

  // Package
  {
    path: adminRouteAbsolute.createPackage,
    component: PackageFormCommonPage,
  },

  {
    path: adminRouteAbsolute.vehicles,
    component: VehiclesCommonPage,
    name: MenuNameEnum.VEHICLES,
    icon: icons.menuIconVehicleInactive,
    activeIcon: icons.menuIconVehicleActive,
    children: [
      {
        path: adminRouteAbsolute.trucks,
        component: TrucksCommonPage,
        name: MenuNameEnum.TRUCKS,
        icon: icons.menuIconTruckInActive,
        activeIcon: icons.menuIconTruckActive,
      },
      {
        path: adminRouteAbsolute.trailers,
        component: TrailerCommonPage,
        name: MenuNameEnum.TRAILERS,
        icon: icons.menuIconTrailerInActive,
        activeIcon: icons.menuIconTrailerActive,
      },
      {
        path: adminRouteAbsolute.equipments,
        component: EquipmentCommonPage,
        name: MenuNameEnum.EQUIPMENTS,
        icon: icons.menuIconEquipmentInActive,
        activeIcon: icons.menuIconEquipmentActive,
      },
    ],
  },

  // Vendors
  {
    path: adminRouteAbsolute.vendors,
    component: VendorsCommonPage,
    name: MenuNameEnum.VENDORS,
    icon: icons.menuIconVendorsInactive,
    activeIcon: icons.menuIconVendorsActive,
  },
  {
    path: adminRouteAbsolute.detailVendor,
    component: VendorsDetailsCommonPage,
  },

  // Purchase Order
  {
    path: adminRouteAbsolute.purchaseOrder,
    component: PurchaseOrderCommonPage,
    name: MenuNameEnum.PURCHASE_ORDER,
    icon: icons.menuIconPurchaseInactive,
    activeIcon: icons.menuIconPurchaseActive,
  },
  {
    path: `${adminRoute.base}${adminRoute.purchaseOrder}${adminRoute.commonDetail}`,
    component: PurchaseOrderDetailsCommonPage,
  },

  // Settings
  {
    path: adminRouteAbsolute.settings,
    component: SettingsCommonPage,
    name: MenuNameEnum.SETTINGS,
    icon: icons.menuIconSettingUnactive,
    activeIcon: icons.menuIconSettingActive,
  },

  // User
  {
    path: adminRouteAbsolute.users,
    component: UserCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.settings}${adminRoute.users}${adminRoute.commonDetail}`,
    component: UserDetailCommonPage,
  },
  {
    path: adminRouteAbsolute.createUser,
    component: UserFormCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.settings}${adminRoute.users}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: UserFormCommonPage,
  },

  // Venue
  {
    path: adminRouteAbsolute.venue,
    component: VenueCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.settings}${adminRoute.venue}${adminRoute.commonDetail}`,
    component: VenueDetailCommonPage,
  },
  {
    path: adminRouteAbsolute.createVenue,
    component: VenueFormCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.settings}${adminRoute.venue}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: VenueFormCommonPage,
  },

  // Role Management
  {
    path: adminRouteAbsolute.roleManagement,
    component: RoleManagementCommonPage,
  },
  {
    path: adminRouteAbsolute.createRole,
    component: RoleFormCommonPage,
  },
  {
    path: `${adminRoute.base}${adminRoute.settings}${adminRoute.roleManagement}${adminRoute.commonDetail}${adminRoute.commonEdit}`,
    component: RoleFormCommonPage,
  },

  // Coupon
  {
    path: adminRouteAbsolute.coupon,
    component: CouponsCommonPage,
  },

  // Event Type
  {
    path: adminRouteAbsolute.eventType,
    component: EventTypeCommonPage,
  },

  // Category
  {
    path: adminRouteAbsolute.category,
    component: CategoryCommonPage,
  },

  // Checklist
  {
    path: adminRouteAbsolute.checklist,
    component: ChecklistCommonPage,
  },
];
